import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const FacebookAuthCallback = () => {
  const location = useLocation();

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const code = urlParams.get('code');
    const error = urlParams.get('error');

    if (code) {
      // Send success message to parent window
      window.opener?.postMessage({
        type: 'FACEBOOK_AUTH_SUCCESS',
        code: code
      }, window.location.origin);
      
      // Close the popup
      window.close();
    } else if (error) {
      // Send error message to parent window
      window.opener?.postMessage({
        type: 'FACEBOOK_AUTH_ERROR',
        error: error
      }, window.location.origin);
      
      // Close the popup
      window.close();
    }
  }, [location]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-rose-600 mx-auto"></div>
        <p className="mt-4 text-sm text-gray-600">Processing Facebook authentication...</p>
      </div>
    </div>
  );
};

export default FacebookAuthCallback;